<template>
  <b-navbar class="full-nav py-2" toggleable="md" type="info" v-if="company">

    <b-navbar-brand class="m-0 my-1 mr-md-3" href="/" :title="companyName">
      <img v-if="companyLogo" :src="companyLogo" alt="" />
      <h2 v-else>{{ companyName }}</h2>
    </b-navbar-brand>

    <b-navbar-nav v-if="$route && `${$route.name}`.startsWith('ShareShow')">
      <b-nav-item :to="{ name: 'ShareShowAll', params: { shareCode: $route.params.shareCode } }" title="All Jobs">
        <font-awesome-icon icon="briefcase"/>
        <span class="d-inline-block d-md-none d-lg-inline-block">All Jobs</span>
      </b-nav-item>
    </b-navbar-nav>
    <template v-else>
      <b-navbar-toggle class="border-0" target="nav_collapse"><font-awesome-icon icon="bars"/></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="nav-wide mt-3 mt-md-0 px-2 px-md-0" v-if="isLoggedIn">
          <b-nav-item :to="{ name: 'Dashboard' }" title="Dashboard">
            <font-awesome-icon icon="home" />
            <span class="d-inline-block d-md-none d-lg-inline-block">Home</span>
          </b-nav-item>
          <b-nav-item-dropdown title="Opportunities">
            <template v-slot:button-content>
              <font-awesome-icon icon="briefcase"/>
              <span class="d-inline-block d-md-none d-lg-inline-block">Opportunities</span>
            </template>
            <b-dropdown-item v-if="isReferralsFeatureEnabled" :to="{ name: 'JobIndex' }">Referral Jobs</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'InternalJobIndex' }">Internal Jobs</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ProjectsIndex' }">Project Roles</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="sitePreferences.isContentShareToolEnabled" :to="{ name: 'ContentShareIndex' }" title="Content Share">
            <font-awesome-icon icon="share-alt" />
            <span class="d-inline-block d-md-none d-lg-inline-block">Content</span>
          </b-nav-item>
          <b-nav-item :to="{ name: 'MentorsIndex' }" title="Mentors">
            <font-awesome-icon icon="users" />
            <span class="d-inline-block d-md-none d-lg-inline-block">Mentors</span>
          </b-nav-item>

          <!-- <b-nav-item to="/candidates"><font-awesome-icon icon="user" />Candidates</b-nav-item> -->

          <template v-if="Array.isArray(leaderboards) && (isRecruiter || visibleInLeaderboards) && isReferralsFeatureEnabled">
            <template v-if="isRecruiter || leaderboards.length > 1">
              <b-nav-item-dropdown title="Leaderboards">
                <template v-slot:button-content>
                  <font-awesome-icon icon="list"/>
                  <span class="d-inline-block d-md-none d-lg-inline-block">Leaderboards</span>
                </template>
                <template v-for="leaderboard in leaderboards">
                  <b-dropdown-item :key="leaderboard.id" :to="{ name: 'LeaderboardShow', params: { leaderboardID: leaderboard.id }}">{{leaderboard.name}}</b-dropdown-item>
                </template>
                <b-dropdown-item v-if="isRecruiter" :to="{ name: 'LeaderboardIndex' }">All Leaderboards</b-dropdown-item>
              </b-nav-item-dropdown>
            </template>
            <template v-else-if="leaderboards.length === 1">
              <b-nav-item :to="{ name: 'LeaderboardShow', params: { leaderboardID: leaderboards[0].id }}" title="Leaderboard">
                <font-awesome-icon icon="list" />
                <span class="d-inline-block d-md-none d-lg-inline-block">Leaderboard</span>
              </b-nav-item>
            </template>
          </template>

          <b-nav-item
            v-if="sitePreferences.isRewardsEnabled && isReferralsFeatureEnabled"
            :to="{ name: sitePreferences.isRewardIntegrationEnabled ? 'RewardsBrowser' : 'RewardsIndex' }"
            title="Rewards"
          >
            <font-awesome-icon icon="store" />
            <span class="d-inline-block d-md-none d-lg-inline-block">Reward Shop</span>
          </b-nav-item>

          <b-nav-item-dropdown v-if="isRecruiter" title="Admin">
            <template v-slot:button-content>
              <font-awesome-icon icon="user-shield"/>
              <span class="d-inline-block d-md-none d-lg-inline-block">Admin</span>
            </template>
            <b-dropdown-item v-if="isRecruiterAdmin" :to="{ name: 'ManageAnalytics' }">
              <font-awesome-icon class="mr-2" icon="chart-area" />Analytics
            </b-dropdown-item>
            <b-dropdown-item v-if="isReferralsFeatureEnabled" :to="{ name: 'ListReferrals' }">
              <font-awesome-icon class="mr-2" icon="link" />Referrals
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ListApplications' }">
              <font-awesome-icon class="mr-2" icon="file-alt" />Applications
            </b-dropdown-item>
            <b-dropdown-item v-if="isRecruiterAdmin" :to="{ name: 'ListUsers' }">
              <font-awesome-icon class="mr-2" icon="users" />Users
            </b-dropdown-item>
            <!-- b-dropdown-item v-if="isRecruiterAdmin" :to="{ name: 'ListUsers' }">
              <font-awesome-icon class="mr-2" icon="graduation-cap" />Talentpool
            </b-dropdown-item -->
            <b-dropdown-item v-if="isRecruiterAdmin" :to="{ name: 'MapSuggestedSkills' }">
              <font-awesome-icon class="mr-2" icon="tag" />Map Skills
            </b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>
        <b-navbar-nav v-else>
          <b-nav-item :to="{ name: 'JobIndex' }" title="All Jobs">
            <font-awesome-icon icon="briefcase"/>
            <span class="d-inline-block d-md-none d-lg-inline-block">All Jobs</span>
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto mt-3 mt-md-0 px-2 px-md-0">
          <template v-if="user">
            <b-button style="font-size: 13px; padding: 0px 15px; height: 32px; margin-top: 6px; margin-right: 12px" pill variant="outline-secondary" size="sm" @click="sendFeedback">
              Beta Feedback
            </b-button>
            <!-- <b-nav-item class="d-inline-flex align-items-top">
              <font-awesome-icon icon="bell"/>
              <span class="d-md-none">Notifications</span>
              <b-badge pill variant="danger">1</b-badge>
            </b-nav-item> -->
            <b-nav-item-dropdown right no-caret toggle-class="py-0">
              <template v-slot:button-content>
                <div class="d-inline-flex justify-content-between align-items-center pt-2" :title="user.fullName">
                  <avatar :user="user" :size="30"/>
                  <div class="ml-3 mr-2" style="line-height: 14px">
                    <b>{{ user.fullName }}</b><br/>{{ user.title }}
                  </div>
                  <font-awesome-icon class="ml-1" icon="caret-down"/>
                </div>
              </template>

              <b-dropdown-item class="text-muted" v-if="!isRecruiter && isReferralsFeatureEnabled" :to="{ name: 'Referrals' }">
                <font-awesome-icon class="mr-2" icon="user-check"/>Referrals
              </b-dropdown-item>
              <b-dropdown-item class="text-muted" v-if="!isRecruiter && sitePreferences.canSyncContacts && isReferralsFeatureEnabled" :to="{ name: 'ReferralRequests' }">
                <font-awesome-icon class="mr-2" icon="user-plus"/>Referral Requests
              </b-dropdown-item>
              <b-dropdown-item class="text-muted" :to="{ name: 'UserApplications' }">
                <font-awesome-icon class="mr-2" icon="address-card"/>Applications
              </b-dropdown-item>
              <b-dropdown-item class="text-muted" :to="{ name: 'UserMentorship' }">
                <font-awesome-icon class="mr-2" icon="chalkboard-teacher"/>Mentorship
              </b-dropdown-item>
              <b-dropdown-item class="text-muted" v-if="!isRecruiter && canSyncContacts && isReferralsFeatureEnabled" :to="{ name: 'ProfileSyncContacts' }">
                <font-awesome-icon class="mr-2" icon="sync"/>Sync Contacts
              </b-dropdown-item>
              <b-dropdown-divider/>
              <span class="ml-2" style="font-size: 14px"><strong>Profile</strong></span>
              <b-dropdown-item class="text-muted" :to="{ name: 'Onboarding', params: { stepName: 'interest' } }">
                <font-awesome-icon class="mr-2" icon="bookmark"/>Interest
              </b-dropdown-item>
              <b-dropdown-item class="text-muted" :to="{ name: 'Onboarding', params: { stepName: 'skills' } }">
                <font-awesome-icon class="mr-2" icon="tags"/>Skills
              </b-dropdown-item>
              <b-dropdown-item class="text-muted" :to="{ name: 'Onboarding', params: { stepName: 'career' } }">
                <font-awesome-icon class="mr-2" icon="briefcase"/>Career Aspirations
              </b-dropdown-item>
              <b-dropdown-item class="text-muted" :to="{ name: 'Onboarding', params: { stepName: 'mentorship' } }">
                <font-awesome-icon class="mr-2" icon="chalkboard-teacher"/>Mentorship Settings
              </b-dropdown-item>
              <b-dropdown-divider/>
              <b-dropdown-item :to="{ name: 'ProfileSessions' }">Your Sessions</b-dropdown-item>
              <b-dropdown-item v-if="company.shortCode" :to="{ name: 'AppPromo' }">Download App</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'ManageApplicationImports' }" v-if="isRecruiterAdmin">Import Applications</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'ManageUserInvites' }">Invite People</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'EmailSender' }" v-if="isRecruiterAdmin || (isDemoSite && isRecruiter)">Send Emails</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'Settings' }" v-if="isRecruiterAdmin">Settings</b-dropdown-item>

              <template v-if="isDemoSite">
                <b-dropdown-divider/>
                <b-dropdown-text tag="div" class="px-0">
                  <demo-nav-opts/>
                </b-dropdown-text>
              </template>

              <b-dropdown-divider/>
              <!-- <b-dropdown-item v-if="company && company.siteBranding && !company.siteBranding.helpURL && isRecruiter" :href="helpURLs['Recruiter-FAQs']" target="_blank"><template v-if="isRecruiterAdmin">Recruiter </template>FAQs</b-dropdown-item> -->
              <!-- <b-dropdown-item v-if="company && company.siteBranding && !company.siteBranding.helpURL" :href="helpURLs['Employee-FAQs']" target="_blank"><template v-if="isRecruiter">Employee </template>FAQs</b-dropdown-item> -->
              <!-- <b-dropdown-item :to="{ name: 'TrainingVideo' }">Training Video</b-dropdown-item> -->
              <b-dropdown-item href="https://support.reallinks.io/hc" v-if="isRecruiterAdmin">Support Centre</b-dropdown-item>
              <!-- <b-dropdown-item v-if="isRecruiterAdmin" :to="{ name: 'RecruiterAdminHelp' }">Administration Guide</b-dropdown-item> -->
              <b-dropdown-item v-if="company && company.siteBranding && company.siteBranding.helpURL" :href="company.siteBranding.helpURL.fileLocation" target="_blank">Help</b-dropdown-item>
              <b-dropdown-item v-if="company && company.siteBranding && company.siteBranding.policyURL" :href="company.siteBranding.policyURL.fileLocation" target="_blank">Policy Details</b-dropdown-item>

              <b-dropdown-item v-if="user.id === 'ADMIN'" :to="{ name: 'LogoutAdmin' }">Back to Admin</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'Logout' }">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </template>
  </b-navbar>
</template>

<script>
// import HeaderEmployeeBadges from '@/graphql/queries/HeaderEmployeeBadges.gql';
// import HeaderRecruiterBadges from '@/graphql/queries/HeaderRecruiterBadges.gql';
import Avatar from '@/components/users/Avatar';
import DemoNavOpts from '@/components/DemoNavOpts';
import helpURLs from '@/assets/helpURLs';
import { mapRoot } from '@/mixins/root';

export default {
  components: {
    Avatar,
    DemoNavOpts,
  },
  // apollo: {
  //   badges: {
  //     query() {
  //       return this.isRecruiter ? HeaderRecruiterBadges : HeaderEmployeeBadges;
  //     },
  //     update: data => data,
  //     skip() {
  //       return !this.isLoggedIn;
  //     }
  //   },
  // },
  computed: {
    ...mapRoot([
      'company', 'user', 'isLoggedIn', 'isRecruiter', 'isRecruiterAdmin',
      'isReferralsFeatureEnabled', 'canSyncContacts',
      'isDemoSite', 'isSainsburys',
    ]),
    companyLogo() {
      const { company } = this;
      return company && company.siteBranding && company.siteBranding.bigLogo ? company.siteBranding.bigLogo.fileLocation : null;
    },
    companyName() {
      const { company } = this;
      return company && company.siteBranding && company.siteBranding.name ? company.siteBranding.name : company.name;
    },
    leaderboards() {
      if (this.isLoggedIn && this.sitePreferences.useGamification) {
        const filterActiveDates = ({ startDate, endDate }) => (!startDate || startDate < Date.now()) && (!endDate || endDate > Date.now());
        if (this.isRecruiter) {
          return (Array.isArray(this.company.leaderboards) ? this.company.leaderboards : []).filter(filterActiveDates);
        } else {
          let leaderboards = (Array.isArray(this.user.leaderboards) ? this.user.leaderboards : []).filter(filterActiveDates).filter(({ hidden }) => (!hidden));
          if (this.company.handle === 'mckesson') {
            leaderboards = leaderboards.filter(({ type }) => type === 'INDIVIDUALS');
          }
          return leaderboards;
        }
      }

      return null;
    },
    visibleInLeaderboards() {
      if (this.isLoggedIn && this.user && this.user.preferences) {
        const { visibleInLeaderboards } = this.user.preferences;
        return visibleInLeaderboards === true || visibleInLeaderboards === null;
      } else {
        return true;
      }
    },
    sitePreferences() {
      const { sitePreferences } = this.company || {};
      return sitePreferences || {};
    },
    helpURLs: () => helpURLs,
    isNewDashboard() {
      const { company } = this;
      return company && company.sitePreferences && company.sitePreferences.isNewDashboard;
    },
  },
  methods: {
    sendFeedback() {
      const emailAddress = 'feedback@reallinks.io';
      const subject = 'Beta Feedback';
      const body = 'Your feedback here...';

      const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

      window.open(mailtoLink);
    }
  }
};
</script>

<style lang="scss">
.navbar.full-nav {
  .navbar-brand {
    img {
      max-height: 30px;
      max-width: 200px;
      object-fit: contain;
    }
  }

  .navbar-nav {
    .svg-inline--fa {
      width: 16px;
    }

    .nav-item {
      font-size: 13px;
    }

    &.nav-wide {
      .svg-inline--fa {
        margin-right: 10px;
      }

      .nav-item {
        padding-right: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderIM.vue